import { BrowserRouter, Routes, Route } from 'react-router-dom';
import {AboutScreen} from './screencomponent/AboutScreen';
import {ContactScreen} from './screencomponent/ContactScreen';
import {LayoutComponent} from './screencomponent/LayoutComponent';
import { MenuScreen } from './screencomponent/MenuScreen';
import { Breakfast } from './screencomponent/MenuScreen/Breakfast';
import { Desserts } from './screencomponent/MenuScreen/Desserts';
import { Dinner } from './screencomponent/MenuScreen/Dinner';
import { Drinks } from './screencomponent/MenuScreen/Drinks';
import { Lunch } from './screencomponent/MenuScreen/Lunch';
import { ScrollToTop } from './screencomponent/ScrollToTop';
import { HomeScreen } from './screencomponent/HomeScreen';


function App() {
  return (
    <BrowserRouter>
    <ScrollToTop />
      <Routes>
          <Route path="" element={<LayoutComponent />}>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/about" element={<AboutScreen />} />
          <Route path="/contact" element={<ContactScreen />} />

         <Route path="/menu" element={<MenuScreen />}/>
            <Route path="/menu/breakfast" element={<Breakfast />} />
            <Route path="/menu/desserts" element={<Desserts />} />
            <Route path="/menu/dinner" element={<Dinner />} />
            <Route path="/menu/drinks" element={<Drinks />} />
            <Route path="/menu/lunch" element={<Lunch />} />
          </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
